import React, { useEffect, useRef, useState } from "react";
import { Button, Card, Form, FormProps } from "antd";
import useDeviceStore from "../../stores/device.store";
import "./ShadowSection.scss";
import ShadowConfigInputs from "./ShadowForm";
import ModeButtons from "./ModeButtons";
import { ShadowConfig } from "../../models/shadow";

interface ShadowSectionProps {
  uuid: string;
}

const ShadowSection = (props: ShadowSectionProps) => {
  const [form] = Form.useForm();
  const changeMode = useDeviceStore((state) => state.changeMode);
  const getMode = useDeviceStore((state) => state.getShadowByDeviceUuid);
  const shadow = useDeviceStore((state) => state.shadows[props.uuid]);
  const [shadowMode, setShadowMode] = useState<string>("FREE");
  const hasInitialized = useRef(false);
  const hasInitialValues = useRef(false);

  const onFinish: FormProps<ShadowConfig>["onFinish"] = (values) => {
    changeMode(props.uuid, shadowMode, values);
  };

  useEffect(() => {
    getMode(props.uuid);

    // Update data every 5 seconds
    const interval = setInterval(() => {
      getMode(props.uuid);
    }, 5000); // 5 seconds

    // Clean up the interval when the component unmounts
    return () => clearInterval(interval);
  }, [getMode, props.uuid]);

  useEffect(() => {
    if (!hasInitialized.current && shadow?.data?.state?.reported?.mode) {
      setShadowMode(shadow.data.state.reported.mode);
      hasInitialized.current = true;
    }
    if (!hasInitialValues.current && shadow?.data?.state?.reported?.configuration) {
      hasInitialValues.current = true;
      form.setFieldsValue({
        payment_active_dispenser_price: shadow.data.state.reported.configuration.payment_active_dispenser_price,
        timeout_sensor_seconds: shadow.data.state.reported.configuration.timeout_sensor_seconds,
        timeout_payment_seconds: shadow.data.state.reported.configuration.timeout_payment_seconds,
        timeout_ready_seconds: shadow.data.state.reported.configuration.timeout_ready_seconds,
        timeout_window_seconds: shadow.data.state.reported.configuration.timeout_window_seconds,
        timeout_water_seconds: shadow.data.state.reported.configuration.timeout_water_seconds
      });
    }
  }, [shadow, form]);


  return (
    <Card title={"Shadow"} className={"ShadowSection"}>
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        autoComplete="off"
      >
        <ModeButtons shadowMode={shadowMode} setShadowMode={setShadowMode} />

        <br />
        <br />
        <ShadowConfigInputs />

        <br />
        <pre>{JSON.stringify(shadow, null, 2)}</pre>

        <Form.Item style={{ textAlign: "right" }}>
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default ShadowSection;